module.exports = __webpack_public_path__ + "img/checklist-otp.a0df4c3d.png";